/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import apiClient from '../../apiClient';
import { DetailOfferType, newOfferDetailsType, createLeadRequestType, updateLeadRequestType } from './types';
export const getOfferDetailsDataByLOC = async (loc: string): Promise<any> => {
  const requestUrl = `${process.env.REACT_APP_API_DOMAIN}${process.env.REACT_APP_GET_OFFER_DETAILS_BY_LOC_API_PATH}${loc}?of=true`;

  const returnValue: any = {
    hasError: false,
    offerDetailsErrorCode: '',
    loading: false,
  };
  try {
    const response = await apiClient.get<DetailOfferType>(requestUrl);
    returnValue.newOfferData = response;
    if (response?.offers === undefined) {
      returnValue.offerDetailsErrorCode = response?.errorCode || 'DEFAULT_ERROR';
      returnValue.hasError = true;
      returnValue.loading = true;
    }
    return returnValue;
  } catch (e: any) {
    console.log('error is:', e);
    returnValue.offerDetailsErrorCode = e?.response?.data?.errorCode || 'DEFAULT_ERROR';
    returnValue.hasError = true;
    return returnValue;
  }
};

export const createNewOfferLead = async (payload: any): Promise<any> => {
  let returnValue: any = {
    hasLeadError: false,
    loading: false,
    hasOffers: false,
  };
  const leadApiUrl: string = `${process.env.REACT_APP_API_DOMAIN}${process.env.REACT_APP_CREATE_LEAD_REQUEST}`;
  //const leadApiUrl = `https://id01-gw-dmz-mm-proxy-pse-api-v1.apps.vacationclub.io/proxy/pse/v1/createLeadRequestInfo`;
  try {
    const leadCreateResponse = await apiClient.post<createLeadRequestType, any>(leadApiUrl, payload);
    returnValue.leadDetail = leadCreateResponse;
  } catch (e: any) {
    returnValue.hasLeadError = true;
  }
  return returnValue;
};
export const updateNewOfferLead = async (payload: any): Promise<any> => {
  let returnValue: any = {
    hasUpdateLeadError: false,
    loading: false,
  };
  const leadUpdateApiUrl: string = `${process.env.REACT_APP_API_DOMAIN}${process.env.REACT_APP_UPDATE_LEAD_REQUEST}`;
  // const leadUpdateApiUrl = `https://id01-gw-dmz-mm-proxy-pse-api-v1.apps.vacationclub.io/proxy/pse/v1/updateLead`;
  try {
    const leadUpdateResponse = await apiClient.put(leadUpdateApiUrl, payload);
    returnValue.updateLeadDetail = leadUpdateResponse;
  } catch (e: any) {
    returnValue.hasUpdateLeadError = true;
  }
  return returnValue;
};
